import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
    padding: "8px 16px 32px 16px",
    backgroundColor: "#F9FAFB",
    minHeight: "100vh",
  },
  bulknotifyblock: {
    marginBottom: "24px",
    width: "100%",
  },
  toolbarRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    flexWrap: "wrap",
    gap: "12px",
  },
  exportButtonGroup: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#111827",
    borderRadius: "8px",
    overflow: "hidden",
    padding: "2px",
    gap: "1px",
    "& .MuiButton-root": {
      color: "#FFFFFF",
      backgroundColor: "#111827",
      fontSize: "13px",
      fontWeight: 500,
      textTransform: "none",
      padding: "6px 16px",
      borderRadius: "6px",
      boxShadow: "none",
      minWidth: "auto",
      "&:hover": {
        backgroundColor: "#1F2937",
      },
    },
  },
  deleteBtn: {
    backgroundColor: "#EF4444",
    color: "#FFFFFF",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "13px",
    padding: "6px 16px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#DC2626",
    },
    "&.Mui-disabled": {
      backgroundColor: "#F3F4F6",
      color: "#9CA3AF",
    },
  },
  dataGridTable: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    border: "1px solid #E5E7EB",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    overflow: "hidden",
    "& .MuiDataGrid-root": {
      border: "none",
      fontFamily: "inherit",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#F9FAFB",
      borderBottom: "1px solid #E5E7EB",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: "13px",
      color: "#374151",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #F3F4F6",
      "&:hover": {
        backgroundColor: "#F9FAFB",
      },
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #F3F4F6",
      fontSize: "14px",
      color: "#111827",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiDataGrid-footerContainer": {
      display: "none",
    },
  },
  idText: {
    fontWeight: 700,
    color: "#111827",
    fontSize: "14px",
  },
  messageText: {
    color: "#4B5563",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  passengerText: {
    color: "#111827",
    fontWeight: 500,
    fontSize: "14px",
  },
  dateText: {
    color: "#6B7280",
    fontSize: "13px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    backgroundColor: "#ffffff",
    borderTop: "1px solid #E5E7EB",
    fontFamily: "inherit",
  },
  paginationText: {
    fontSize: "14px",
    color: "#6B7280",
    fontWeight: "500",
  },
  paginationControls: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  pageButton: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    color: "#475569 !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#f1f5f9 !important",
    },
  },
  pageButtonActive: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#ffffff !important",
    backgroundColor: "#111827 !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#1F2937 !important",
    },
  },
  pageDots: {
    padding: "0 4px",
    color: "#94a3b8",
    fontSize: "14px",
    fontWeight: "500",
    userSelect: "none",
  },
  pageArrow: {
    color: "#64748b",
    cursor: "pointer",
    transition: "color 0.2s",
    "&:hover": {
      color: "#0f172a",
    },
    "&.disabled": {
      color: "#cbd5e1",
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  },
}));

export default useStyles;
